import React, { Component } from "react";
import { connect } from "react-redux";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdrLocMiscMaterialsRowV3 extends Component {
  state = {
    formData: {
      materialDescription: "",
      vendorName: "",
      invoiceNo: "",
      quantity: 0,
      miscMaterialsUnitOfMeasureId: 0,
    },
  };

  componentDidMount() {
    const { miscMaterial: locMm } = this.props;
    const formData = {
      materialDescription: locMm.materialDescription,
      vendorName: locMm.vendorName,
      invoiceNo: locMm.invoiceNo,
      quantity: locMm.quantity,
      miscMaterialsUnitOfMeasureId: locMm.miscMaterialsUnitOfMeasureId,
    };
    this.setState({ formData });
  }

  componentDidUpdate(prevProps) {
    // CDU here fixes the issue of this component showing stale data after deleting LMMs.
    // TODO: is there a better way?
    const { miscMaterial: prevLocMm } = prevProps;
    const { miscMaterial: currLocMm } = this.props;
    if (
      prevLocMm.materialDescription !== currLocMm.materialDescription ||
      prevLocMm.vendorName !== currLocMm.vendorName ||
      prevLocMm.invoiceNo !== currLocMm.invoiceNo ||
      prevLocMm.quantity !== currLocMm.quantity ||
      prevLocMm.miscMaterialsUnitOfMeasureId !== currLocMm.miscMaterialsUnitOfMeasureId
    ) {
      this.setState({
        formData: {
          materialDescription: currLocMm.materialDescription || "",
          vendorName: currLocMm.vendorName || "",
          invoiceNo: currLocMm.invoiceNo || "",
          quantity: currLocMm.quantity,
          miscMaterialsUnitOfMeasureId: currLocMm.miscMaterialsUnitOfMeasureId,
        },
      });
    }
  }

  handleChange = (e) =>
    this.setState(
      { formData: { ...this.state.formData, [e.target.name]: e.target.value } },
      this.props.markAdrDirty
    );

  handleChange_select = (e) => {
    const { update, markAdrDirty } = this.props;
    update({ [e.target.name]: e.target.value });
    markAdrDirty();
  };

  handleBlur = (e) => this.props.update({ [e.target.name]: e.target.value });

  render() {
    const { formData } = this.state;
    const {
      status,
      wpTabId,
      clientId,
      locMmIndex,
      handleClick_delete,
      miscMaterialsUnitsOfMeasure,
    } = this.props;
    const idSuffix = `${wpTabId}_${clientId}_${locMmIndex}`;
    return (
      <div className="locwp-row-mm__tr">
        <div className="locwp-row-mm__td--desc">
          <input
            type="text"
            name="materialDescription"
            id={`locMmDescription_${idSuffix}`}
            className="form-control px-1"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.materialDescription}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-mm__td--vendor">
          <input
            type="text"
            name="vendorName"
            id={`locMmVendor_${idSuffix}`}
            className="form-control px-1"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.vendorName}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-mm__td--invoice">
          <input
            type="text"
            name="invoiceNo"
            id={`locMmInvoice_${idSuffix}`}
            className="form-control px-1"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.invoiceNo}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-mm__td--qty">
          <input
            type="number"
            name="quantity"
            id={`locMmQuantity_${idSuffix}`}
            className="form-control px-1"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.quantity}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-mm__td--uom">
          <select
            name="miscMaterialsUnitOfMeasureId"
            id={`locMmUoM_${idSuffix}`}
            className="form-control mr-1 px-1"
            onChange={this.handleChange_select}
            value={formData.miscMaterialsUnitOfMeasureId}
            disabled={status.isReadOnly}
          >
            <option key="mmUomKey_0" value={0}>
              (Select a Unit)
            </option>
            {miscMaterialsUnitsOfMeasure &&
              miscMaterialsUnitsOfMeasure.map((uom) => (
                <option
                  key={`mmUomKey_${uom.miscMaterialsUnitOfMeasureId}`}
                  value={uom.miscMaterialsUnitOfMeasureId}
                >
                  {uom.unitOfMeasure}
                </option>
              ))}
          </select>
        </div>
        <div className="locwp-row-mm__td--del">
          <button
            name="deleteLocMiscMaterialsRow"
            id={`deleteLocMm_${idSuffix}`}
            className="btn btn-outline-danger px-2"
            type="button"
            onClick={handleClick_delete(locMmIndex)}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="times" className="fa-fw" />
          </button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  update: (fields) =>
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.MISC_MATERIALS.UPDATE,
      tabId: ownProps.tabId,
      wpTabId: ownProps.wpTabId,
      clientId: ownProps.clientId,
      locMmIndex: ownProps.locMmIndex,
      fields,
    }),
});

const mapStateToProps = (state) => ({
  miscMaterialsUnitsOfMeasure: state.feederLists.miscMaterialsUnitsOfMeasure || [],
});

export default connect(mapStateToProps, mapDispatchToProps)(AdrLocMiscMaterialsRowV3);
